// One reading of "where is my work?", used by the header icon and the pill.
export function syncState({ online, pending, rejected }) {
  if (rejected) {
    return { tone: 'bad', label: rejected === 1 ? '1 change needs attention' : `${rejected} changes need attention`, count: rejected };
  }
  if (!online) return { tone: 'warn', label: pending ? `Offline, ${pending} waiting to send` : 'Offline', count: pending };
  if (pending) return { tone: 'busy', label: `Sending ${pending}…`, count: pending };
  return { tone: 'ok', label: 'All changes saved', count: 0 };
}
